import { CSSObject } from 'styled-components';

export const fadeOut: CSSObject = { '@keyframes fadeOut': { from: { opacity: 1 }, to: { opacity: 0 } } };

export const fadeIn: CSSObject = { '@keyframes fadeIn': { from: { opacity: 0 }, to: { opacity: 1 } } };
